import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { ImportedEmploymentsCustomerService } from './imported-employments-customer.service';

const service = new ImportedEmploymentsCustomerService();

export interface ImportedEmploymentsCustomerState {}

const ImportedEmploymentsCustomerStore: Module<ImportedEmploymentsCustomerState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getImportedEmploymentsCustomers(context, query?: LocationQuery) {
         return await service.getImportedEmploymentsCustomers(query);
      },
   },
};

export default ImportedEmploymentsCustomerStore;
